const normalizeCategoryId = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : value;
};

export const mergeCreatedCategoryIntoCatalog = (catalog = [], createdCategory) => {
  const baseCatalog = Array.isArray(catalog) ? catalog : [];
  if (!createdCategory || createdCategory.id == null) {
    return baseCatalog;
  }

  if (baseCatalog.some((category) => String(category.id) === String(createdCategory.id))) {
    return baseCatalog;
  }

  const explicitParentId = createdCategory.parent_id ?? createdCategory.parentId ?? null;
  const inferredParent = explicitParentId == null && createdCategory.parentName
    ? baseCatalog.find((category) => category.parent_id == null && category.name === createdCategory.parentName)
    : null;
  const resolvedParentId = explicitParentId ?? inferredParent?.id ?? null;

  return [
    ...baseCatalog,
    {
      ...createdCategory,
      id: normalizeCategoryId(createdCategory.id),
      parent_id: normalizeCategoryId(resolvedParentId),
      budget: createdCategory.budget ?? null,
    },
  ];
};
